import { useContext, useState } from "react";
import { DonationPageStateContext } from "../state";


export const EarmarkingTerm = () => {
    
    const { state } = useContext(DonationPageStateContext);
    const nonEarmarkedCandidates = state.recipients.filter(r => r.donationAmount?.amount && r.earmarked == false).map(r => r.displayName).join(", ");
    if (!nonEarmarkedCandidates) {
        return <></>;
    }
    return (
        <p className="earmarking-term">Contributions to the following candidates are direct donations in accordance with FEC Advisory Opinion 2011-06 and do not constitute earmarked contributions within the meaning of 11 C.F.R. §110.6(b): {nonEarmarkedCandidates}</p>
    );
}